/**
 * Created by Sergey Panpurin on 11/16/2016.
 */

(function btConstantsClosure() {
  'use strict';

  /**
   * @namespace window.plugins.googleplus
   * @property {Function} trySilentLogin - ?
   */

  /**
   * @namespace $window.StripeCheckout
   * @property {Function} configure - ?
   */

  /**
   * @namespace $window.AppRate
   * @property {object} preferences - ?
   * @property {object} preferences.callbacks - ?
   * @property {*} preferences.callbacks.onButtonClicked - ?
   * @property {*} promptForRating - ?
   */

  /**
   * @namespace $window.facebookConnectPlugin
   * @property {*} login - ?
   * @property {*} logout - ?
   * @property {*} getAccessToken - ?
   */

  // console.log('Raven', window.Raven !== undefined);

  // console.log('AppRate', window.AppRate !== undefined);
  // console.log('facebookConnectPlugin', window.facebookConnectPlugin !== undefined);
  // console.log('plugins.googleplus', (window.plugins ? window.plugins.googleplus : undefined) !== undefined);
  // console.log('plugins.OneSignal', (window.plugins ? window.plugins.OneSignal : undefined) !== undefined);
  // console.log(
  //   'cordova.plugins.LinkedIn',
  //   (window.cordova && window.cordova.plugins ? window.cordova.plugins.LinkedIn : undefined) !== undefined
  // );

  angular
    .module('ecapp')
    // application version constants
    .constant('appVersions', {
      mainVersion: window.mainVersion,
      herokuVersion: window.btSettings.HEROKU_RELEASE_VERSION,
      herokuCommit: window.btSettings.HEROKU_SLUG_COMMIT,
      releaseHash: window.releaseHash,
    })
    .constant('btSymbolPrefix', {
      FOREX: 'FX',
      STOCK: 'ST',
      CRYPT: 'CR',
    })
    .constant('BT', {
      ORDER_TYPE: {
        LIMIT: 'Limit',
        MARKET: 'Market',
        STOP: 'Stop',
      },
      TRADE_ACTION: {
        BUY: 'BUY',
        SELL: 'SELL',
      },
    })
    .constant('TS', {
      DURATION: {
        DAY: 'DAY',
        DYP: 'DYP',
        GTC: 'GTC',
        GCP: 'GCP',
        GTD: 'GTD',
        GDP: 'GDP',
        OPG: 'OPG',
        CLO: 'CLO',
        IOC: 'IOC',
        FOK: 'FOK',
        M1: '1',
        M3: '3',
        M5: '5',
      },
      ORDER_TYPE: {
        LIMIT: 'Limit',
        STOP_MARKET: 'StopMarket',
        MARKET: 'Market',
        STOP_LIMIT: 'StopLimit',
      },
      ACCOUNT_TYPE: {
        CRYPTO: 'Crypto',
      },
      ASSET_TYPE: {
        UNKNOWN: 'UNKNOWN',
        STOCK: 'STOCK',
        STOCK_OPTION: 'STOCKOPTION',
        FUTURE: 'FUTURE',
        FUTURE_OPTION: 'FUTUREOPTION',
        FOREX: 'FOREX',
        CURRENCY_OPTION: 'CURRENCYOPTION',
        INDEX: 'INDEX',
        INDEX_OPTION: 'INDEXOPTION',
        MUTUAL_FUND: 'MUTUALFUND',
        MONEY_MARKET_FUND: 'MONEYMARKETFUND',
        BOND: 'BOND',
        CRYPTO: 'CRYPTO',
      },
      TRADE_ACTION: {
        BUY: 'BUY',
        SELL: 'SELL',
        BUYTOCOVER: 'BUYTOCOVER',
        SELLSHORT: 'SELLSHORT',
        BUYTOOPEN: 'BUYTOOPEN',
        BUYTOCLOSE: 'BUYTOCLOSE',
        SELLTOOPEN: 'SELLTOOPEN',
        SELLTOCLOSE: 'SELLTOCLOSE',
      },
    })
    .constant('btSettings', window.btSettings)
    .constant('$ionicLoadingConfig', {
      template: '<ion-spinner icon="ios"></ion-spinner>',
    })
    .constant('Raven', window.Raven)
    // .constant('cordovaAppRate', window.AppRate)
    // .constant('cordovaFacebookConnect', window.facebookConnectPlugin)
    // .constant('cordovaGooglePlus', (window.plugins) ? window.plugins.googleplus : null)
    // .constant('cordovaOneSignal', (window.plugins) ? window.plugins.OneSignal : null)
    // .constant('cordovaLinkedIn', (window.cordova && window.cordova.plugins) ? window.cordova.plugins.LinkedIn : null)
    .constant(
      'btDefaultSpeechImage',
      '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'
    )
    .constant(
      'btDefaultReportImage',
      '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'
    );
})();
